import { getIsUpdated } from '../../Menu/utils';
import { Box,  Flex, Heading, Text, useStyleConfig } from '@chakra-ui/react';
import MenuLink from './MenuLink';

const MenuItem = ({ props, sectionTitle, sectionSubTitle, sectionName }) => {
  const variant = 'wrapper';
  const style = window.appType === 'city' ? {width: '100%'} : {};
  const buttonStyles = useStyleConfig('Button', { variant });
    const updated = getIsUpdated(props, sectionName);
    return (
      <Flex
        flexDirection='row'
        justifyContent='space-between'
        alignItems='center'
        width='100%'
      >
        <Box >
        <Heading variant='b18' width='100%'>
          {sectionTitle}
        </Heading>
        <Text >{sectionSubTitle}</Text>
        </Box>
          <Box>
            <MenuLink props={props} sectionName={sectionName} updated={updated} buttonStyles={buttonStyles} />
        </Box>
      </Flex>
    );

};

export default MenuItem;